// src/pages/Login.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api/api";
import { FaUser, FaLock } from "react-icons/fa";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post("/account/login", { username, password });

      if (res.data.success) {
        localStorage.setItem("user", JSON.stringify(res.data.data));
        navigate("/dashboard");
      }
    } catch (err) {
      alert("Login failed");
    }
  };

  return (
    <div
      className="container-fluid vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: "linear-gradient(135deg,#6C63FF,#3F3D56)"
      }}
    >
      <div className="row w-100 justify-content-center">
        <div className="col-md-4 col-lg-3">

          <div className="card shadow-lg p-4" style={{ borderRadius: "15px" }}>

            <div className="text-center mb-4">
              <h3 className="text-primary fw-bold">Welcome Back</h3>
              <p className="text-muted small">Sign in to your account</p>
            </div>

            <form onSubmit={handleLogin}>

              <div className="input-group mb-3">
                <span className="input-group-text bg-primary text-white">
                  <FaUser />
                </span>
                <input
                  className="form-control"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              <div className="input-group mb-4">
                <span className="input-group-text bg-primary text-white">
                  <FaLock />
                </span>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100 fw-bold"
                style={{ borderRadius: "10px" }}
              >
                Login
              </button>

            </form>

          </div>

        </div>
      </div>
    </div>
  );
}